import common from './common'
import app from './app'
import table from './table'
import edit from './edit'
import chart from './chart'
import tree from './tree'

export default {
  common,
  app,
  table,
  edit,
  chart,
  tree,
}